<template>
  <main class="container-1 terrain-campaign-responses">
    <div class="container-header">
      <Breadcrumb :links="routesBread" />
    </div>

    <section class="container-body terrain-campaign-responses__body">
      <div class="terrain-campaign-responses__toolbar">
        <div class="terrain-campaign-responses__view-toggle">
          <button type="button" :class="{ active: viewMode === 'table' }" @click="viewMode = 'table'">Tabla</button>
          <button type="button" :class="{ active: viewMode === 'cards' }" @click="viewMode = 'cards'">Tarjetas</button>
        </div>
        <button
          v-if="canReview"
          type="button"
          class="terrain-campaign-responses__edit-toggle"
          :class="{ active: editMode }"
          @click="toggleEditMode"
        >
          {{ editMode ? "Salir de edición" : "Modo edición" }}
        </button>
      </div>

      <TerrainResponsesTable v-if="viewMode === 'table'" :campaign-id="campaignId" :edit-mode="editMode" @dirty-change="dirty = $event" />
      <TerrainReviewQueue v-else hide-chrome :edit-mode="editMode" @dirty-change="dirty = $event" />
    </section>
  </main>
</template>

<script>
// TerrainCampaignResponses.vue reemplaza a TerrainReviewQueue como
// componente de la ruta terrain-campaign-responses: la tabla (nueva) queda
// como vista por defecto, la vista de tarjetas de siempre (TerrainReviewQueue,
// sin tocar su lógica) pasa a secundaria detrás de este toggle. La ruta
// global /terreno/revision sigue apuntando a TerrainReviewQueue directo, sin
// cambios.
import Breadcrumb from "../../components/Breadcrumb.vue";
import TerrainResponsesTable from "../../components/terrain/TerrainResponsesTable.vue";
import TerrainReviewQueue from "./TerrainReviewQueue.vue";
import { createTerrainApi } from "../../services/terrain/api.js";

export default {
  name: "TerrainCampaignResponses",
  components: { Breadcrumb, TerrainResponsesTable, TerrainReviewQueue },
  data() {
    return {
      viewMode: "table",
      campaignName: "",
      // editMode es dueño único de la bandera para ambas vistas (tabla y
      // tarjetas) — se pasa como prop a la que esté activa. dirty refleja
      // si la vista activa tiene cambios sin guardar (evento dirty-change),
      // para poder confirmar antes de apagar el modo edición.
      editMode: false,
      dirty: false,
    };
  },
  computed: {
    campaignId() { return this.$route.params.campaignId; },
    routesBread() {
      return [
        { name: "Terreno" },
        { name: "Campañas", path: "/terreno/campanas" },
        { name: this.campaignName || "Respuestas" },
      ];
    },
    terrainApi() { return createTerrainApi(this.$http, this.$store.getters.backendurl); },
    canReview() { return Boolean((this.$store.getters.getPermissions || {}).terrain && this.$store.getters.getPermissions.terrain.review); },
  },
  created() {
    this.loadCampaignName();
  },
  methods: {
    async loadCampaignName() {
      try {
        const response = await this.terrainApi.getCampaign(this.campaignId);
        this.campaignName = (response.data && response.data.name) || "";
      } catch (error) {
        // El breadcrumb cae de vuelta a "Respuestas"; no es un error bloqueante
        // (mismo criterio que TerrainReviewQueue.vue::loadCampaignName).
      }
    },
    toggleEditMode() {
      if (this.editMode && this.dirty) {
        this.$modal.show("dialog", {
          text: "Hay cambios sin guardar. ¿Salir de todos modos? Se perderán.",
          buttons: [
            { title: "Cancelar" },
            { title: "Salir sin guardar", handler: () => { this.$modal.hide("dialog"); this.dirty = false; this.editMode = false; } },
          ],
        });
        return;
      }
      this.editMode = !this.editMode;
    },
  },
};
</script>

<style scoped>
.terrain-campaign-responses__body { display: flex; flex-direction: column; gap: var(--terrain-space-md); }
.terrain-campaign-responses__toolbar { display: flex; justify-content: space-between; align-items: center; gap: var(--terrain-space-md); }
.terrain-campaign-responses__view-toggle { display: inline-flex; border: 1px solid var(--color-line); border-radius: 6px; overflow: hidden; }
.terrain-campaign-responses__view-toggle button {
  padding: 6px 14px;
  border: 0;
  background: var(--color-white);
  color: var(--color-graphite);
  cursor: pointer;
  font-size: 0.85em;
  font-weight: 600;
}
.terrain-campaign-responses__view-toggle button + button { border-left: 1px solid var(--color-line); }
.terrain-campaign-responses__view-toggle button.active { background: var(--color-navy); color: var(--color-white); }

.terrain-campaign-responses__edit-toggle {
  border: 0;
  border-radius: var(--terrain-radius-xl);
  background: var(--color-navy);
  color: var(--color-white);
  cursor: pointer;
  font-weight: 600;
  padding: var(--terrain-space-sm) var(--terrain-space-lg);
  transition: background-color var(--terrain-transition);
}
.terrain-campaign-responses__edit-toggle:hover { background: var(--color-steel); }
.terrain-campaign-responses__edit-toggle.active { background: var(--color-orange); }
</style>
